export default __webpack_public_path__ + "static/media/Marino.70c8a04e.jpg";